












































































































































































































































































































































































































































import {
  FinancialDocumentStatusEnum,
  FinancialDocumentTypesEnum,
  PaymentMeansEnum,
  ReservationStatusEnum,
} from "@/shared/models/enums.type";
import { FinancialDocumentStatus } from "@/shared/models/financialDocumentStatus";
import { FinancialSettingsType } from "@/store/modules/financial";
import {
  Component,
  Prop,
  PropSync,
  Ref,
  Vue,
  Watch,
} from "vue-property-decorator";
import { Action, Getter } from "vuex-class";
import {
  FinancialDocumentCreateResponseModel,
  FinancialDocumentFiscalizeResult,
  FinancialDocumentLockResult,
  FinancialDocumentSaveLockAndMarkAsPaidResult,
  FinDocClientInfoViewModel,
  FinDocLineItemViewModel,
  FinDocViewModel,
  OwnersInvoiceBulkCreateResult,
  PaymentModel,
} from "./FinancialDocumentFormParts/models";
import LoadingOverlay from "@/components/misc/LoadingOverlay.vue";
import FinancialDocumentReservationSummary from "./FinancialDocumentReservationSummary.vue";
import BasicInfo from "./FinancialDocumentFormParts/BasicInfo.vue";
import ClientInfo from "./FinancialDocumentFormParts/ClientInfo.vue";
import LineItems from "./FinancialDocumentFormParts/LineItems.vue";
import PriceSummary from "./FinancialDocumentFormParts/PriceSummary.vue";
import { TaxRateView } from "@/shared/models/taxRates";
import {
  fillInvoiceEditingTaxExemptionReason,
  clearTaxExemption,
  calculateLineItem,
  getPriceSummary,
} from "./FinancialDocumentFormParts/functions";
import { saveFile } from "@/shared/saveFile";
import { AgencyWorkModelsEnum } from "@/shared/models/agencyWorkModel";
import { BusinessUnit } from "@/shared/models/businessUnit";
import { CashRegisterModel } from "@/shared/models/cashRegister";
import { PaymentMean } from "@/shared/models/paymentMean";
import FinDocPrepaymentsModal from "../misc/FinDocPrepaymentsModal.vue";
import { ApiErrorsRuleBroken } from "@/shared/models/apiErrors";
import * as _ from "lodash";
import FinancialDocumentPaymentsModal from "./FinancialDocumentPaymentsModal.vue";
import { round } from "../numbers/numberFormatUtils";
import { Notification } from "@/store/modules/notifications";

@Component({
  components: {
    LoadingOverlay,
    FinancialDocumentReservationSummary,
    BasicInfo,
    ClientInfo,
    LineItems,
    PriceSummary,
    FinDocPrepaymentsModal,
    FinancialDocumentPaymentsModal,
  },
})
export default class FinancialDocumentModalForm extends Vue {
  @PropSync("open") isOpen?: boolean;
  @PropSync("documentId", { default: null }) internalDocumentId?: number | null;
  @Prop() reservationStatusId?: number | null;

  @PropSync("deleteOnClose", { default: false })
  internalDeleteOnClose?: boolean;

  @Prop({ default: FinancialDocumentTypesEnum.Racun })
  newDocumentTypeId?: FinancialDocumentTypesEnum;

  @Prop({ default: false }) skipPrepaymentMarking?: boolean;

  messages: string[] = [];
  hasTaxRecapError = false;

  loading = false;
  changeReservationStatus = false;

  finDocModel: FinDocViewModel = new FinDocViewModel();

  agencyWorkModelsEnum = AgencyWorkModelsEnum;
  financialDocumentTypesEnum = FinancialDocumentTypesEnum;

  get confirmReservation() {
    if (
      this.reservationStatusId == ReservationStatusEnum.Hold &&
      this.finDocModel.documentTypeId ==
        FinancialDocumentTypesEnum.RacunZaPredujam &&
      this.finDocModel.documentStatusId != FinancialDocumentStatusEnum.Placen
    ) {
      this.changeReservationStatus =
        this.automaticallyChangeReservationStatusToConfirmed ?? false;
      return true;
    } else {
      this.changeReservationStatus = false;
      return false;
    }
  }

  get isCancellation() {
    return (
      this.finDocModel.documentTypeId === FinancialDocumentTypesEnum.Storno
    );
  }

  get isLocked() {
    return (
      this.finDocModel.documentStatusId !== FinancialDocumentStatusEnum.UIzradi
    );
  }

  get documentStatus() {
    const key = this.financialDocumentStatuses?.find(
      (x) => x.id === this.finDocModel.documentStatusId
    )?.textResourceKey;

    return key ? this.$t(key).toString() : "";
  }

  get title() {
    let key = "";
    switch (this.finDocModel.documentTypeId) {
      case FinancialDocumentTypesEnum.Racun:
        key = "FinancialDocument.Editing.Invoice";
        break;
      case FinancialDocumentTypesEnum.Ponuda:
        key = "FinancialDocument.Editing.Quote";
        break;
      case FinancialDocumentTypesEnum.RacunZaPredujam:
        key = "FinancialDocument.Editing.AdvanceInvoice";
        break;
      case FinancialDocumentTypesEnum.Storno:
        key = "FinancialDocument.Editing.InvoiceCancelation";
        break;
      case FinancialDocumentTypesEnum.Otpremnica:
        key = "FinancialDocument.Editing.DeliveryNote";
        break;
      case FinancialDocumentTypesEnum.VlasnikovRacun:
        key = "FinancialDocument.Editing.OwnersInvoice";
        break;
      case FinancialDocumentTypesEnum.RacunZaProviziju:
        key = "FinancialDocument.Editing.CommissionInvoice";
        break;
    }
    return key ? this.$t(key).toString() : "";
  }

  get hasTaxExemption() {
    return this.finDocModel.lineItems.some(
      (x) => (this.taxRates?.find((e) => e.id === x.taxRateId)?.rate ?? 0) === 0
    );
  }

  get hasLineItems() {
    return this.finDocModel.lineItems.length > 0;
  }

  // functions
  async close() {
    if (
      this.finDocModel.documentStatusId ===
        FinancialDocumentStatusEnum.UIzradi &&
      this.finDocModel.id &&
      this.internalDeleteOnClose
    ) {
      await this.deleteDraftOnClose();
    }

    this.hasTaxRecapError = false;
    this.internalDeleteOnClose = false;
    this.isOpen = false;
  }

  async deleteDraftOnClose() {
    Vue.axios
      .delete(`/financialDocuments/${this.finDocModel.id}`)
      .then(() => {
        this.loading = true;
      })
      .finally(() => {
        this.loading = false;
        this.$emit("refresh");
      });
  }

  @Watch("isOpen")
  isOpenWatch(fresh: boolean) {
    if (!fresh) {
      this.internalDocumentId = null;
    } else {
      this.extraOptions.automaticallyCancelRelatedAdvanceInvoices =
        this.automaticRelatedAdvanceInvoiceCancellingDefault ?? false;
    }

    this.$nextTick(() => this.refresh(null));
  }

  refresh(documentId: number | null = null) {
    this.internalDocumentId = documentId ?? this.internalDocumentId;
    this.$nextTick(async () => {
      if (this.internalDocumentId) {
        this.loading = true;
        await Vue.axios
          .get<FinDocViewModel>(`FinancialDocuments/${this.internalDocumentId}`)
          .then((e) => {
            this.finDocModel = {
              ...e.data,
            };

            // to make sure Vue can detect changes properly
            this.finDocModel.clientInfo = {
              ...new FinDocClientInfoViewModel(),
              ...this.finDocModel.clientInfo,
            };

            this.finDocModel.lineItems.forEach((e) =>
              calculateLineItem(
                e,
                this.taxRates ?? [],
                this.finDocModel.workingToFormalConversionRate,
                this.finDocModel
              )
            );

            this.formRef?.resetValidation();
          })
          .finally(() => (this.loading = false));
      } else {
        if (this.taxRates && this.storedSettings) {
          const today = new Date();
          const issueDate = today.toISOString().substring(0, 10);
          const deliveryDate = today.toISOString().substring(0, 10);
          today.setDate(
            today.getDate() + (this.storedSettings?.invoiceDueDays ?? 0)
          );
          const dueDate = today.toISOString().substring(0, 10);

          const defaultRate = this.storedSettings.standardTaxRate;
          const outOfScopeOrDefaultRate =
            this.storedSettings.outOfScopeTaxRate ??
            this.storedSettings.standardTaxRate;

          this.finDocModel = new FinDocViewModel();

          this.finDocModel.workingCurrencyId =
            this.storedSettings.workingCurrency.id;
          this.finDocModel.workingCurrencyISO3 =
            this.storedSettings.workingCurrency.isoCode;
          this.finDocModel.workingToFormalConversionRate =
            this.workingToFormalConversionRate;

          this.finDocModel.formalCurrencyId =
            this.storedSettings.formalCurrency?.id ??
            this.storedSettings.workingCurrency.id;
          this.finDocModel.formalCurrencyISO3 =
            this.storedSettings.formalCurrency?.isoCode ??
            this.storedSettings.workingCurrency.isoCode;
          this.finDocModel.formalToWorkingConversionRate =
            this.formalToWorkingConversionRate;

          // historic currency commented out as no one uses it anymore (app param values have been hard deleted)
          // so I'm not bothering to re-implement it with the simplified multicurrency system
          // this.finDocModel.historicCurrencyId = this.storedSettings.historicCurrency?.id;
          // this.finDocModel.historicCurrencyISO3 = this.storedSettings.historicCurrency?.isoCode;

          // this.finDocModel.workingToFormalConversionRate = this.storedSettings.workingToFormalConversionRate;
          // this.finDocModel.historicCurrencyConversionRate = this.storedSettings.historicConversionRate;

          this.finDocModel.documentTypeId =
            this.newDocumentTypeId ?? FinancialDocumentTypesEnum.Racun;
          this.finDocModel.basicInfo.issueDate = issueDate;
          this.finDocModel.basicInfo.deliveryDate = deliveryDate;
          this.finDocModel.basicInfo.dueDate = dueDate;
          this.finDocModel.basicInfo.businessUnitId = this.isOpen
            ? this.activeBusinessUnit?.id ?? null
            : null;
          this.finDocModel.basicInfo.cashRegisterId = this.isOpen
            ? this.activeCashRegister?.id ?? null
            : null;
          this.finDocModel.basicInfo.issuePlace =
            this.activeBusinessUnit?.city ?? "";
          this.finDocModel.basicInfo.paymentMeansId =
            this.storedSettings?.paymentMeansId ?? null;

          if (
            !this.finDocModel.lineItems ||
            this.finDocModel.lineItems.length === 0
          ) {
            this.finDocModel.lineItems = [
              {
                ...new FinDocLineItemViewModel(),
                itemNumber: 1,
                taxRateId: this.storedSettings?.paysVat
                  ? defaultRate.id
                  : outOfScopeOrDefaultRate.id,
              },
            ];

            calculateLineItem(
              this.finDocModel.lineItems[0],
              this.taxRates ?? [],
              this.finDocModel.workingToFormalConversionRate,
              this.finDocModel
            );

            fillInvoiceEditingTaxExemptionReason(
              this.finDocModel,
              this.finDocModel.lineItems.some((e) => e.isStayCancellation),
              this.paysVat
            );
          }

          this.formRef?.resetValidation();
        }
      }
    });
  }

  async sleep() {
    await new Promise((resolve) => setTimeout(resolve, 150));
  }

  extraOptions = {
    automaticallyCancelRelatedAdvanceInvoices: false,
    fiscalizeOfferDeliveryNote: false,
    createOwnersInvoicesCheckbox: false,
  };

  get canAutomaticallyCancelRelatedAdvanceInvoices() {
    return (
      this.finDocModel.relatedAdvanceInvoices &&
      this.finDocModel.relatedAdvanceInvoices.length > 0 &&
      this.finDocModel.documentTypeId === FinancialDocumentTypesEnum.Racun &&
      this.finDocModel.documentStatusId === FinancialDocumentStatusEnum.UIzradi
    );
  }

  get showActionButtons() {
    return (
      this.finDocModel.documentStatusId === FinancialDocumentStatusEnum.UIzradi
    );
  }

  get showSaveAndLockButton() {
    return (
      this.finDocModel.documentStatusId ===
        FinancialDocumentStatusEnum.UIzradi &&
      //prepayment invoices cannot be 'locked' -> only 'paid'
      this.finDocModel.documentTypeId !==
        FinancialDocumentTypesEnum.RacunZaPredujam
    );
  }

  get showFiscalizeCheckbox() {
    return (
      (this.storedSettings?.fiscalizeOffers &&
        this.finDocModel.documentTypeId ===
          FinancialDocumentTypesEnum.Ponuda) ||
      (this.storedSettings?.fiscalizeDeliveryNotes &&
        this.finDocModel.documentTypeId ===
          FinancialDocumentTypesEnum.Otpremnica)
    );
  }

  get lineItemsForOwnersInvoice() {
    return this.finDocModel.lineItems.filter(
      (x) =>
        x.reservationAccUnitTypeId &&
        !x.addOnServiceId &&
        x.agencyWorkModelId == AgencyWorkModelsEnum.OwnNameAndOtherInvoice
    );
  }
  get canCreateOwnersInvoices() {
    return (
      this.finDocModel.documentTypeId === FinancialDocumentTypesEnum.Racun &&
      (this.finDocModel.documentStatusId ===
        FinancialDocumentStatusEnum.UIzradi ||
        this.finDocModel.documentStatusId ===
          FinancialDocumentStatusEnum.Zakljucen) &&
      this.lineItemsForOwnersInvoice.length > 0 &&
      this.finDocModel.reservationId &&
      this.finDocModel.lineItems
        .filter((x) => x.ownerIsLegalEntity != undefined)
        .some((x) => !x.ownerIsLegalEntity)
    );
  }
  get showCreateOwnersInvoicesCheckbox() {
    return (
      this.canCreateOwnersInvoices &&
      this.finDocModel.documentStatusId === FinancialDocumentStatusEnum.UIzradi
    );
  }

  get showStornoButton() {
    return (
      this.isLocked &&
      !this.isCancellation &&
      this.finDocModel.documentStatusId !==
        FinancialDocumentStatusEnum.Storniran &&
      this.finDocModel.documentTypeId !== FinancialDocumentTypesEnum.Ponuda &&
      this.finDocModel.documentTypeId !== FinancialDocumentTypesEnum.Otpremnica
    );
  }

  get showMarkAsPaidButton() {
    // return true when status is Locked or Due and doc type is not STORNO or OFFER
    // return true if unpaid advance invoice
    return (
      (this.finDocModel.documentTypeId !== FinancialDocumentTypesEnum.Storno &&
        this.finDocModel.documentTypeId !== FinancialDocumentTypesEnum.Ponuda &&
        this.finDocModel.documentTypeId !==
          FinancialDocumentTypesEnum.Otpremnica &&
        (this.finDocModel.documentStatusId ===
          FinancialDocumentStatusEnum.Dospio ||
          this.finDocModel.documentStatusId ===
            FinancialDocumentStatusEnum.Zakljucen)) ||
      (this.finDocModel.documentTypeId ===
        this.financialDocumentTypesEnum.RacunZaPredujam &&
        this.finDocModel.documentStatusId !==
          FinancialDocumentStatusEnum.Placen)
    );
  }

  autoAdvanceInvoiceCancellationDetailsDialogOpen = false;
  autoAdvanceInvoiceCancellationDetailsDialogIsValid = false;
  autoAdvanceInvoiceCancellationBackupBusinessUnitId: null | number = null;
  autoAdvanceInvoiceCancellationBackupCashRegisterId: null | number = null;
  autoAdvanceInvoiceCancellationDetailsDialogAction:
    | "save"
    | "saveAndLock"
    | "saveForPDF" = "save";

  openAutoAdvanceInvoiceCancellationDetails(
    saveActionType: "save" | "saveAndLock" | "saveForPDF"
  ) {
    this.autoAdvanceInvoiceCancellationBackupBusinessUnitId =
      this.finDocModel.basicInfo.businessUnitId ?? null;
    this.autoAdvanceInvoiceCancellationBackupCashRegisterId =
      this.finDocModel.basicInfo.cashRegisterId ?? null;
    this.autoAdvanceInvoiceCancellationDetailsDialogAction = saveActionType;
    this.autoAdvanceInvoiceCancellationDetailsDialogOpen = true;
  }

  autoAdvanceInvoiceCancellationDetailsDialogContinue() {
    if (this.autoAdvanceInvoiceCancellationDetailsDialogAction === "save") {
      this.save(true, true, false, true);
    } else if (
      this.autoAdvanceInvoiceCancellationDetailsDialogAction === "saveAndLock"
    ) {
      this.lockConfirmation(true);
    } else if (
      this.autoAdvanceInvoiceCancellationDetailsDialogAction === "saveForPDF"
    ) {
      this.downloadPdfDocument(true);
    }

    this.autoAdvanceInvoiceCancellationDetailsDialogOpen = false;
  }

  // save changes
  finDocCreateResponseDialogOpen = false;
  finDocCreateResponseDialogData:
    | FinancialDocumentCreateResponseModel
    | FinancialDocumentSaveLockAndMarkAsPaidResult
    | null = null;
  closeAutoCancellationDialog() {
    this.finDocCreateResponseDialogOpen = false;
    this.finDocCreateResponseDialogData = null;
  }

  @Ref("form") formRef?: {
    reset: () => void;
    resetValidation: () => void;
    validate: () => boolean;
  };

  async save(
    refresh = true,
    skipAutoAdvanceInvoiceCancellationBackups = false,
    isForPDF = false,
    showMessages = true
  ) {
    this.internalDeleteOnClose = false;
    this.loading = true;
    await this.sleep();

    const formvalid = this.formRef?.validate() ?? false;

    if (!formvalid) {
      this.$store.dispatch("showNotification", {
        color: "error",
        message: this.$t("Validation.InputErrors"),
        timeout: 5000,
      });
      this.loading = false;
      throw new Error("Validation.InputErrors");
    }

    if (
      !skipAutoAdvanceInvoiceCancellationBackups &&
      this.extraOptions.automaticallyCancelRelatedAdvanceInvoices &&
      this.canAutomaticallyCancelRelatedAdvanceInvoices
    ) {
      const checkResponse = await this.axios.get<boolean>(
        "FinancialDocuments/CheckBusinessUnitStatus",
        {
          params: {
            financialDocumentIds: (
              this.finDocModel.relatedAdvanceInvoices.map((x) => x.id) ?? []
            ).join(","),
          },
        }
      );

      if (!checkResponse.data) {
        this.openAutoAdvanceInvoiceCancellationDetails(
          isForPDF ? "saveForPDF" : "save"
        );
        this.loading = false;
        return false;
      }
    }

    let saveSuccess = false;
    this.hasTaxRecapError = false;
    await Vue.axios
      .post<FinancialDocumentCreateResponseModel>("financialDocuments", {
        ...this.finDocModel,
        automaticallyCancelRelatedAdvanceInvoices:
          this.extraOptions.automaticallyCancelRelatedAdvanceInvoices,
        autoAdvanceInvoiceCancellationBackupBusinessUnitId:
          this.autoAdvanceInvoiceCancellationBackupBusinessUnitId,
        autoAdvanceInvoiceCancellationBackupCashRegisterId:
          this.autoAdvanceInvoiceCancellationBackupCashRegisterId,
      })
      .then((res) => {
        this.finDocModel.id = res.data.documentId;
        if (refresh) this.refresh(res.data.documentId);
        saveSuccess = true;
        this.messages.push("FinancialDocument.SaveSuccess");

        if (
          res.data.advanceInvoiceCancellationResults &&
          res.data.advanceInvoiceCancellationResults.length > 0
        ) {
          this.finDocCreateResponseDialogData = _.cloneDeep(res.data);
        }
      })
      .catch((error) => {
        const data = error.data as ApiErrorsRuleBroken;
        const isTaxRecap =
          data.code === "RuleBroken" &&
          data.brokenRules.some(
            (br) => br.name === "TaxRecap.Validation.TaxRecapNotValid"
          );
        if (isTaxRecap) {
          this.hasTaxRecapError = true;
        }
      })
      .finally(() => {
        if (refresh) this.loading = false;
        if (showMessages) this.showMessages();
      });

    return saveSuccess;
  }

  async lockConfirmation(skipAutoAdvanceInvoiceCancellationBackups = false) {
    this.loading = true;
    await this.sleep();

    const formvalid = this.formRef?.validate() ?? false;

    if (!formvalid) {
      this.$store.dispatch("showNotification", {
        color: "error",
        message: this.$t("Validation.InputErrors"),
        timeout: 5000,
      });
      this.loading = false;
      throw new Error("Validation.InputErrors");
    }

    if (
      !skipAutoAdvanceInvoiceCancellationBackups &&
      this.extraOptions.automaticallyCancelRelatedAdvanceInvoices &&
      this.canAutomaticallyCancelRelatedAdvanceInvoices
    ) {
      const checkResponse = await this.axios.get<boolean>(
        "FinancialDocuments/CheckBusinessUnitStatus",
        {
          params: {
            financialDocumentIds: (
              this.finDocModel.relatedAdvanceInvoices.map((x) => x.id) ?? []
            ).join(","),
          },
        }
      );

      if (!checkResponse.data) {
        this.openAutoAdvanceInvoiceCancellationDetails("saveAndLock");
        this.loading = false;
        return;
      }
    }

    const actions = [
      {
        text: this.$t("Yes"),
        fun: async () => {
          await this.lockDocument();
          return true;
        },
      },
      {
        text: this.$t("FinancialDocument.YesAndMarkAsPaid"),
        fun: () => {
          this.openPaymentModal();
          return true;
        },
      },
      {
        text: this.$t("Cancel"),
        fun: () => {
          return true;
        },
      },
    ];

    // if doc type is STORNO or PONUDA or OTPREMNICA, remove YesAndMarkAsPaidAction
    if (
      this.finDocModel.documentTypeId === FinancialDocumentTypesEnum.Storno ||
      this.finDocModel.documentTypeId === FinancialDocumentTypesEnum.Ponuda ||
      this.finDocModel.documentTypeId === FinancialDocumentTypesEnum.Otpremnica
    ) {
      actions.splice(1, 1);
    }

    this.$store.dispatch("showNotification", {
      id: this.finDocModel.id,
      color: "warning",
      message: this.$t("FinancialDocument.AreYouSureYouWishToLock"),
      actions: actions,
      timeout: 5000,
    } as Notification);
    this.loading = false;
  }
  async lockDocument() {
    try {
      const saved = await this.save(false, true, false, false);
      if (saved) {
        await this.lock(true);

        if (
          this.finDocModel.documentTypeId === FinancialDocumentTypesEnum.Storno
        ) {
          this.$emit("refreshReservation");
        }
        if (
          this.canCreateOwnersInvoices &&
          this.extraOptions.createOwnersInvoicesCheckbox
        ) {
          await this.createOwnersInvoices();
        }
      }
    } finally {
      this.showMessages();
    }
  }
  // lock and fiscalize
  async lock(refresh = true) {
    this.loading = true;

    await Vue.axios
      .put<FinancialDocumentLockResult>(
        `financialDocuments/${this.finDocModel.id}/lock`,
        {
          fiscalizeOfferOrDeliveryNote:
            this.extraOptions.fiscalizeOfferDeliveryNote,
        }
      )
      .then((res) => {
        if (res.data.locked)
          this.messages.push("FinancialDocument.LockSuccess");

        if (res.data.fiscalized && this.shouldFiscalize)
          this.messages.push("FinancialDocument.FiscalizationSuccess");
        else if (this.shouldFiscalize) {
          this.$store.dispatch("showNotification", {
            color: "error",
            message:
              this.$t("FinancialDocument.FiscalizationFailed") +
              "\n" +
              (res.data.errorMessage ? res.data.errorMessage : ""),
            timeout: 5000,
          });
        }

        if (refresh) this.refresh(this.finDocModel.id);
      })
      .finally(() => (this.loading = false));
  }

  get shouldFiscalize() {
    return (
      this.paymentMeansId !== PaymentMeansEnum.TransakcijskiRacun &&
      this.paymentMeanBaseId !== PaymentMeansEnum.TransakcijskiRacun &&
      this.paymentMeansId !== PaymentMeansEnum.Cek &&
      this.paymentMeanBaseId !== PaymentMeansEnum.Cek &&
      this.tenantIsFiscalizationObligor &&
      ((this.finDocModel.documentTypeId === FinancialDocumentTypesEnum.Ponuda &&
        this.extraOptions.fiscalizeOfferDeliveryNote) ||
        this.finDocModel.documentTypeId !==
          FinancialDocumentTypesEnum.Ponuda) &&
      ((this.finDocModel.documentTypeId ===
        FinancialDocumentTypesEnum.Otpremnica &&
        this.extraOptions.fiscalizeOfferDeliveryNote) ||
        this.finDocModel.documentTypeId !==
          FinancialDocumentTypesEnum.Otpremnica)
    );
  }

  // download PDF
  async downloadPdfDocument(skipAutoAdvanceInvoiceCancellationBackups = false) {
    if (!this.isLocked) {
      const saved = await this.save(
        false,
        skipAutoAdvanceInvoiceCancellationBackups,
        true,
        true
      );
      if (!saved) return;
    }

    this.loading = true;

    try {
      const res = await Vue.axios.get(
        `financialDocuments/${this.finDocModel.id}/pdfDocument`,
        {
          params: {
            $skip: 0,
            $top: null,
          },
          responseType: "blob",
        }
      );

      const groups = /filename=(?<filename>[^;]+);/.exec(
        res.headers["content-disposition"]
      )?.groups;
      saveFile(res.data, groups?.filename ?? "Finances.xlsx");

      return res;
    } finally {
      this.loading = false;
    }
  }

  // fiscalize
  async fiscalize(refresh = true) {
    this.loading = true;
    await this.sleep();

    await Vue.axios
      .put<FinancialDocumentFiscalizeResult>(
        `financialDocuments/${this.finDocModel.id}/fiscalize`,
        {}
      )
      .then((res) => {
        if (res.data.fiscalized)
          this.messages.push("FinancialDocument.FiscalizationSuccess");
        else {
          this.$store.dispatch("showNotification", {
            color: "error",
            message:
              this.$t("FinancialDocument.FiscalizationFailed") +
              "\n" +
              res.data.errorMessage,
            timeout: 5000,
          });
        }

        if (refresh) this.refresh(null);
      })
      .finally(() => (this.loading = false));
  }

  // mark as paid
  get totalToPay() {
    const summary = getPriceSummary(this.finDocModel);
    return this.extraOptions.automaticallyCancelRelatedAdvanceInvoices
      ? summary.toPayWithoutAdvance
      : summary.toPay;
  }
  amountDue: number | null = null;

  paymentsForFinDocDialogOpen = false;

  // create cancellation document (storno)
  async cancel() {
    this.loading = true;
    await this.sleep();

    await Vue.axios
      .post<number>(`financialDocuments/${this.finDocModel.id}/cancel`, {
        businessUnitId: this.activeBusinessUnit?.id ?? null,
        cashRegisterId: this.activeCashRegister?.id ?? null,
      })
      .then((res) => {
        this.refresh(res.data);
        this.internalDeleteOnClose = true; // so the storno will be deleted if user closes the form without saving
      })
      .finally(() => (this.loading = false));
  }

  async createOwnersInvoices() {
    this.loading = true;
    if (this.lineItemsForOwnersInvoice.length > 0) {
      await this.axios
        .post<OwnersInvoiceBulkCreateResult[]>(
          "financialDocuments/CreateAndLockOwnersInvoicesForReservationUnits",
          {
            reservationId: this.finDocModel.reservationId,
            reservationUnitIds: this.lineItemsForOwnersInvoice.map(
              (x) => x.reservationAccUnitTypeId
            ),
            culture: this.internalLanguage,
          }
        )
        .then((res) => {
          if (res.data.length === 0) {
            this.messages.push(
              "FinancialDocument.CreateOwnersInvoices.NoInvoicesCreated"
            );
          } else {
            this.messages.push(
              "FinancialDocument.CreateOwnersInvoices.Success"
            );

            if (res.data.some((x) => !x.locked))
              this.messages.push(
                "FinancialDocument.CreateOwnersInvoices.LockingFailed"
              );
            else
              this.messages.push(
                "FinancialDocument.CreateOwnersInvoices.LockingSuccess"
              );
          }
        })
        .catch(() => {
          this.$store.dispatch("showNotification", {
            color: "error",
            message: this.$t("FinancialDocument.CreateOwnersInvoices.Failed"),
            timeout: 5000,
          });
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }

  paymentsList: PaymentModel[] = [];

  async openPaymentModal() {
    this.loading = true;
    let amountPaid = 0;
    if (
      this.finDocModel.reservationId != null &&
      this.finDocModel.reservationId != 0
    ) {
      await Vue.axios
        .get<PaymentModel[]>("FinancialDocuments/GetUnassignedPayments", {
          params: {
            reservationId: this.finDocModel.reservationId,
            financiaDoumentId: this.finDocModel.id,
          },
        })
        .then((res) => {
          this.paymentsList = res.data;
          amountPaid = round(
            this.paymentsList.reduce(
              (sum, x) =>
                sum +
                (x.currencyId === this.finDocModel.formalCurrencyId
                  ? x.alreadyPaidForFinDoc ?? 0
                  : round(
                      (x.alreadyPaidForFinDoc ?? 0) *
                        this.finDocModel.workingToFormalConversionRate,
                      2
                    )),
              0
            ) ?? 0,
            2
          );
        });
    }

    this.amountDue = round(this.totalToPay - amountPaid, 2);
    const today = new Date();

    //if there are no existing payments
    if (
      this.paymentsList === null ||
      this.paymentsList === undefined ||
      this.paymentsList.length === 0
    ) {
      if (
        (this.finDocModel.basicInfo.paymentMeansId ===
          PaymentMeansEnum.Ostalo ||
          this.paymentMeanBaseId === PaymentMeansEnum.Ostalo) &&
        this.amountDue != 0
      ) {
        if (
          this.finDocModel.basicInfo.paymentMeansAdditionalDetails &&
          this.finDocModel.basicInfo.paymentMeansAdditionalDetails.length > 0
        ) {
          const paymentDate = (
            this.finDocModel.documentTypeId ===
            FinancialDocumentTypesEnum.RacunZaPredujam
              ? this.finDocModel.basicInfo.deliveryDate ?? today.toISOString()
              : today.toISOString()
          ).substring(0, 10);
          const paymentTime = today.toISOString().substring(11);

          this.paymentsList =
            this.finDocModel.basicInfo.paymentMeansAdditionalDetails?.map(
              (e) => {
                return {
                  id: 0,
                  paymentDate: paymentDate + "T" + paymentTime,
                  amount: e.amount,
                  remainingAmount: e.amount,
                  amountToAsign: e.amount,
                  currencyId: e.currencyId,
                  paymentMeansId: e.paymentMeansId,
                  cardTypeId: e.cardTypeId,
                } as PaymentModel;
              }
            ) ?? [];
          this.saveLockAndMarkAsPaid();
        } else {
          this.paymentsList = [
            {
              id: 0,
              remainingAmount: 0,
              amountToAsign: 0,
              paymentMeansId: null,
              cardTypeId: null,
              amount: 0,
              currencyId: this.finDocModel.formalCurrencyId,
              currencyCode: this.finDocModel.formalCurrencyISO3,
              paymentDate: "",
              alreadyPaidForFinDoc: null,
            },
            {
              id: 0,
              remainingAmount: 0,
              amountToAsign: 0,
              paymentMeansId: null,
              cardTypeId: null,
              amount: 0,
              currencyId: this.finDocModel.formalCurrencyId,
              currencyCode: this.finDocModel.formalCurrencyISO3,
              paymentDate: "",
              alreadyPaidForFinDoc: null,
            },
          ];
          this.loading = false;
          this.paymentsForFinDocDialogOpen = true;
        }
      } else if (
        ((this.paymentMeanBaseId === PaymentMeansEnum.TransakcijskiRacun ||
          this.finDocModel.basicInfo.paymentMeansId ===
            PaymentMeansEnum.TransakcijskiRacun) &&
          this.amountDue != 0) ||
        (this.finDocModel.documentTypeId ==
          FinancialDocumentTypesEnum.RacunZaPredujam &&
          this.finDocModel.basicInfo.deliveryDate?.slice(0, 10) !=
            new Date().toISOString().slice(0, 10))
      ) {
        this.paymentsList = [
          {
            id: 0,
            remainingAmount: this.amountDue,
            amountToAsign: this.amountDue,
            paymentMeansId: this.finDocModel.basicInfo.paymentMeansId,
            cardTypeId: this.finDocModel.basicInfo.cardTypeId,
            amount: this.amountDue,
            currencyId: this.finDocModel.formalCurrencyId,
            currencyCode: this.finDocModel.formalCurrencyISO3,
            paymentDate: today.toISOString(),
            alreadyPaidForFinDoc: null,
          },
        ];

        // for owner's invoices, mark as paid automatically, otherwise open the payments modal
        if (
          this.finDocModel.documentTypeId ===
          FinancialDocumentTypesEnum.VlasnikovRacun
        ) {
          this.saveLockAndMarkAsPaid();
        } else {
          this.loading = false;
          this.paymentsForFinDocDialogOpen = true;
        }
      } else {
        this.paymentsList = [
          {
            id: 0,
            remainingAmount: this.amountDue,
            amountToAsign: this.amountDue,
            paymentMeansId: this.finDocModel.basicInfo.paymentMeansId,
            cardTypeId: this.finDocModel.basicInfo.cardTypeId,
            amount: this.amountDue,
            currencyId: this.finDocModel.formalCurrencyId,
            currencyCode: this.finDocModel.formalCurrencyISO3,
            paymentDate: today.toISOString(),
            alreadyPaidForFinDoc: null,
          },
        ];
        this.saveLockAndMarkAsPaid();
      }
    }
    //if there is one existing payment that covers the due amount of the fin doc
    //just skip the payment modal opening and use that payment to link
    else if (
      this.paymentsList.length === 1 &&
      this.paymentsList.reduce(
        (sum, x) => sum + (x.remainingAmount ?? 0),
        0
      ) === this.amountDue
    ) {
      this.paymentsList = [
        {
          id: this.paymentsList[0].id,
          remainingAmount: this.paymentsList[0].remainingAmount,
          amountToAsign: this.paymentsList[0].remainingAmount,
          paymentMeansId: this.paymentsList[0].paymentMeansId,
          cardTypeId: this.paymentsList[0].cardTypeId,
          amount: this.paymentsList[0].remainingAmount,
          currencyId: this.paymentsList[0].currencyId,
          currencyCode: this.paymentsList[0].currencyCode,
          paymentDate: today.toISOString(),
          alreadyPaidForFinDoc: null,
        },
      ];
      this.saveLockAndMarkAsPaid();
    }
    //if there are existing payments
    else {
      this.loading = false;
      this.paymentsForFinDocDialogOpen = true;
    }
  }

  async saveLockAndMarkAsPaid() {
    this.internalDeleteOnClose = false;
    this.loading = true;
    await this.sleep();

    const formvalid = this.formRef?.validate() ?? false;

    if (!formvalid) {
      this.$store.dispatch("showNotification", {
        color: "error",
        message: this.$t("Validation.InputErrors"),
        timeout: 5000,
      });
      this.loading = false;
      throw new Error("Validation.InputErrors");
    }

    if (
      this.extraOptions.automaticallyCancelRelatedAdvanceInvoices &&
      this.canAutomaticallyCancelRelatedAdvanceInvoices
    ) {
      const checkResponse = await this.axios.get<boolean>(
        "FinancialDocuments/CheckBusinessUnitStatus",
        {
          params: {
            financialDocumentIds: (
              this.finDocModel.relatedAdvanceInvoices.map((x) => x.id) ?? []
            ).join(","),
          },
        }
      );

      if (!checkResponse.data) {
        this.loading = false;
        return false;
      }
    }

    const paymentsForRequest = this.paymentsList.filter(
      (e) => e.amountToAsign !== 0
    );

    //if the document is already locked - just mark it as paid
    if (
      this.finDocModel.documentStatusId ===
      FinancialDocumentStatusEnum.Zakljucen
    ) {
      await Vue.axios
        .put(`financialDocuments/${this.finDocModel.id}/markaspaid`, {
          payments: paymentsForRequest,
          changeReservationStatusToConfirmed: this.changeReservationStatus,
        })
        .then(() => {
          this.messages.push("FinancialDocument.MarkAsPaidSuccess");
          this.paymentsList = [];
          this.amountDue = 0;
          this.paymentsForFinDocDialogOpen = false;
          this.refresh(null);
        })
        .finally(() => {
          this.loading = false;
          this.showMessages();
          this.$emit("refreshReservation");
        });
    } else {
      let saveSuccess = false;
      this.hasTaxRecapError = false;

      await Vue.axios
        .post<FinancialDocumentSaveLockAndMarkAsPaidResult>(
          "financialDocuments/SaveLockAndMarkFinancialDocumentAsPaid",
          {
            ...this.finDocModel,
            unassignedPayments: paymentsForRequest,
            automaticallyCancelRelatedAdvanceInvoices:
              this.extraOptions.automaticallyCancelRelatedAdvanceInvoices,
            autoAdvanceInvoiceCancellationBackupBusinessUnitId:
              this.autoAdvanceInvoiceCancellationBackupBusinessUnitId,
            autoAdvanceInvoiceCancellationBackupCashRegisterId:
              this.autoAdvanceInvoiceCancellationBackupCashRegisterId,
            changeReservationStatusToConfirmed: this.changeReservationStatus,
            fiscalizeOfferOrDeliveryNote:
              this.extraOptions.fiscalizeOfferDeliveryNote,
          }
        )
        .then((res) => {
          saveSuccess = true;
          if (!this.internalDocumentId) {
            this.internalDocumentId = res.data.documentId;
          }
          this.messages.push("FinancialDocument.SaveSuccess");
          this.paymentsList = [];
          this.amountDue = 0;
          if (res.data.locked)
            this.messages.push("FinancialDocument.LockSuccess");
          if (res.data.fiscalized)
            this.messages.push("FinancialDocument.FiscalizationSuccess");
          if (res.data.paid) {
            this.messages.push("FinancialDocument.MarkAsPaidSuccess");
            if (paymentsForRequest.some((e) => e.id !== 0)) {
              this.messages.push(
                "FinancialDocument.MarkAsPaidSuccess.ExistingPaymentsLinked"
              );
            }
            if (paymentsForRequest.some((e) => e.id === 0)) {
              this.messages.push(
                "FinancialDocument.MarkAsPaidSuccess.NewPaymentsCreated"
              );
            }
          }
          if (!res.data.pdfGenerated) {
            this.messages.push("FinancialDocument.PdfNotGenerated");
          }
          if (
            this.canCreateOwnersInvoices &&
            this.extraOptions.createOwnersInvoicesCheckbox
          ) {
            this.createOwnersInvoices();
          }

          if (
            res.data.advanceInvoiceCancellationResults &&
            res.data.advanceInvoiceCancellationResults.length > 0
          ) {
            this.finDocCreateResponseDialogData = _.cloneDeep(res.data);
          }
          this.paymentsForFinDocDialogOpen = false;
        })
        .catch((error) => {
          const data = error.data as ApiErrorsRuleBroken;
          const isTaxRecap =
            data.code === "RuleBroken" &&
            data.brokenRules.some(
              (br) => br.name === "TaxRecap.Validation.TaxRecapNotValid"
            );
          if (isTaxRecap) {
            this.hasTaxRecapError = true;
          }
        })
        .finally(() => {
          this.loading = false;
          if (saveSuccess) {
            this.refresh(null);
          }
          this.showMessages();
          this.$emit("refreshReservation");
        });

      return saveSuccess;
    }
  }

  showMessages() {
    this.loading = false;

    // show auto prepayment invoice cancellation results dialog if there's anything to show
    if (this.finDocCreateResponseDialogData !== null) {
      this.finDocCreateResponseDialogOpen = true;
    }

    const formatSuccessMessages = (x: string[]) =>
      x
        .map((h) => this.$t(h).toString())
        .map((th) => (th.endsWith(".") ? th : th + "."))
        .join(" ");

    const fiscalizationFailed = this.messages.findIndex(
      (x) => x === "FinancialDocument.FiscalizationFailed"
    );

    const pdfNotGenerated = this.messages.findIndex(
      (x) => x === "FinancialDocument.PdfNotGenerated"
    );

    if (fiscalizationFailed !== -1) {
      this.messages.splice(fiscalizationFailed, 1);
      this.$store.dispatch("showNotification", {
        color: "error",
        message: this.$t("FinancialDocument.FiscalizationFailed"),
        timeout: 5000,
      });
    }

    if (pdfNotGenerated !== -1){
      this.messages.splice(pdfNotGenerated, 1);
      this.$store.dispatch("showNotification", {
        color: "error",
        message: this.$t("FinancialDocument.PdfNotGenerated"),
        timeout: 5000,
      });
    }

    const ownersInvoicesCreationFailed = this.messages.findIndex(
      (x) => x === "FinancialDocument.CreateOwnersInvoices.NoInvoicesCreated"
    );
    if (ownersInvoicesCreationFailed !== -1) {
      this.messages.splice(ownersInvoicesCreationFailed, 1);
      this.$store.dispatch("showNotification", {
        color: "error",
        message: this.$t(
          "FinancialDocument.CreateOwnersInvoices.NoInvoicesCreated"
        ),
        timeout: 5000,
      });
    }

    const ownersInvoicesLockingFailed = this.messages.findIndex(
      (x) => x === "FinancialDocument.CreateOwnersInvoices.LockingFailed"
    );
    if (ownersInvoicesLockingFailed !== -1) {
      this.messages.splice(ownersInvoicesLockingFailed, 1);
      this.$store.dispatch("showNotification", {
        color: "error",
        message: this.$t(
          "FinancialDocument.CreateOwnersInvoices.LockingFailed"
        ),
        timeout: 5000,
      });
    }

    if (this.messages.length > 0) {
      this.$store.dispatch("showNotification", {
        color: "success",
        message: formatSuccessMessages(this.messages),
        timeout: 5000,
      });
    }

    this.messages = [];

    this.$emit("refresh");
  }

  changedShowOwnerDetails() {
    if (this.isOpen && this.finDocModel && this.storedSettings) {
      const userInput = clearTaxExemption(
        this.finDocModel.lineItems,
        this.finDocModel.taxExemptionReason
      );

      const accomodationTaxRateId =
        this.storedSettings.accomodationUnitTypesTaxRate.id;
      const outOfScopeTaxRateId = this.storedSettings.outOfScopeTaxRate.id;

      const showOwnerDetails = this.finDocModel.basicInfo.showOwnerDetails;
      const stayLineItems = this.finDocModel.lineItems.filter(
        (e) =>
          e.reservationAccUnitTypeId &&
          !e.addOnServiceId &&
          e.agencyWorkModelId === AgencyWorkModelsEnum.OtherNameAndOtherInvoice
      );

      stayLineItems.forEach((e) => {
        if (showOwnerDetails) {
          e.taxRateId = e.ownerPaysVAT
            ? accomodationTaxRateId
            : outOfScopeTaxRateId;
        } else {
          e.taxRateId = this.paysVat
            ? accomodationTaxRateId
            : outOfScopeTaxRateId;
        }
      });

      fillInvoiceEditingTaxExemptionReason(
        this.finDocModel,
        this.finDocModel.lineItems.some((e) => e.isStayCancellation),
        this.paysVat
      );

      if (userInput !== "" && userInput != undefined) {
        if (this.finDocModel.taxExemptionReason != "")
          this.finDocModel.taxExemptionReason += "\n" + userInput;
        else this.finDocModel.taxExemptionReason += userInput;
      }
    }
  }

  get paymentMeansId() {
    return this.finDocModel.basicInfo.paymentMeansId;
  }

  get paymentMeanBaseId() {
    return this.paymentMeans?.find(
      (e) => e.id === this.finDocModel.basicInfo.paymentMeansId
    )?.paymentMeanBaseId;
  }

  // validation
  get rules() {
    return {
      required: (value: any) =>
        !!value || this.$t("Validation.Required").toString(),
      maxLength: (max: number) => (v: string) =>
        (v != undefined && v != null && v.length <= max) ||
        this.$t("Validation.MaxLength", { count: max }),
    };
  }

  // settings
  get fiscalNumberIsMain() {
    return this.storedSettings?.setFiscalNumberAsMain ?? false;
  }

  get documentMainNumber() {
    if (this.storedSettings?.setFiscalNumberAsMain) {
      return this.finDocModel.documentIdentifier;
    }
    return this.finDocModel.documentInternalIdentifier;
  }

  get documentSecondaryNumber() {
    if (this.storedSettings?.setFiscalNumberAsMain) {
      return this.finDocModel.documentInternalIdentifier;
    }
    return this.finDocModel.documentIdentifier;
  }

  get businessUnits() {
    return (
      this.allBusinessUnits?.filter(
        (x) => x.status && !x.isOwnerBusinessUnit
      ) ?? []
    );
  }

  get cashRegistersForBusinessUnit() {
    return (
      this.allCashRegisters?.filter(
        (x) =>
          x.status &&
          x.businessUnitId ===
            this.autoAdvanceInvoiceCancellationBackupBusinessUnitId
      ) ?? []
    );
  }

  get workingToFormalConversionRate() {
    return this.storedSettings?.workingToFormalConversionRate ?? 1;
  }
  get formalToWorkingConversionRate() {
    return this.storedSettings?.formalToWorkingConversionRate ?? 1;
  }

  get internalLanguage() {
    return this.language ?? "hr-HR";
  }

  get paysVat() {
    return this.storedSettings?.paysVat ?? false;
  }

  // getters and setup
  // prettier-ignore
  @Action("financial/refreshModel") refreshSettings?: () => Promise<void>;
  @Getter("financial/settings") storedSettings?: FinancialSettingsType;

  @Getter("language/language") language?: string;

  // prettier-ignore
  @Action("codebooks/refreshFinancialDocumentStatuses") refreshFinancialDocumentStatuses?: () => Promise<void>;
  @Getter("codebooks/financialDocumentStatuses")
  financialDocumentStatuses?: FinancialDocumentStatus[];

  @Action("codebooks/refreshTaxRates") refreshTaxRates?: () => Promise<void>;
  @Getter("codebooks/taxRates") taxRates?: TaxRateView[];

  @Getter("appParams/tenantIsFiscalizationObligor")
  tenantIsFiscalizationObligor?: boolean;

  @Getter("appParams/automaticallyChangeReservationStatusToConfirmed")
  automaticallyChangeReservationStatusToConfirmed?: boolean;

  @Getter("businessUnit/allBusinessUnits") allBusinessUnits?: BusinessUnit[];
  @Getter("cashRegister/allCashRegisters")
  allCashRegisters?: CashRegisterModel[];

  @Action("businessUnit/refreshBusinessUnits")
  refreshBusinessUnits?: () => void;

  @Action("codebooks/refreshPaymentMeans")
  refreshPaymentMeans?: () => Promise<void>;
  @Getter("codebooks/paymentMeans") paymentMeans?: PaymentMean[];

  @Getter("appParams/cashRegisterFeatureFlag")
  cashRegisterFeature?: boolean;

  // also used for paid prepayments for cancellations (storno fin docs)
  @Getter("appParams/showUnpaidPrepaymentsModal")
  showUnpaidPrepaymentsModal?: boolean;

  @Getter("businessUnit/activeBusinessUnit") activeBusinessUnit?: BusinessUnit;
  @Getter("cashRegister/activeCashRegister")
  activeCashRegister?: CashRegisterModel;

  // prettier-ignore
  @Getter("appParams/automaticRelatedAdvanceInvoiceCancellingDefault") automaticRelatedAdvanceInvoiceCancellingDefault?: boolean;

  // TODO: refresh all fin doc relevant codebooks here (implement new action that does it all in one call)
  async created() {
    const promises = [];

    if (!this.storedSettings && this.refreshSettings) {
      promises.push(this.refreshSettings());
    }

    if (
      (this.financialDocumentStatuses?.length ?? 0) === 0 &&
      this.refreshFinancialDocumentStatuses
    ) {
      promises.push(this.refreshFinancialDocumentStatuses());
    }

    if ((this.taxRates?.length ?? 0) === 0 && this.refreshTaxRates) {
      promises.push(this.refreshTaxRates());
    }

    if (this.refreshBusinessUnits) {
      promises.push(this.refreshBusinessUnits());
    }

    if ((this.paymentMeans?.length ?? 0) === 0 && this.refreshPaymentMeans) {
      promises.push(this.refreshPaymentMeans());
    }

    await Promise.all(promises);
  }
}
